import { State } from '../state';

type Subscriber = (state: State) => void;
export type SubscribeToStateChanges = ReturnType<typeof createSubscriptionMiddleware>['subscribeToStateChanges'];
export type UnsubscribeFromStateChanges = ReturnType<typeof createSubscriptionMiddleware>['unsubscribeFromStateChanges'];

export const createSubscriptionMiddleware = () => {
  const subscribers: Subscriber[] = [];

  return {
    subscriptionMiddleware: (state: State) => {
      subscribers.forEach((subscriber) => {
        subscriber(state);
      });
    },
    subscribeToStateChanges: (subscriber: Subscriber) => subscribers.push(subscriber),
    unsubscribeFromStateChanges: (subscriber: Subscriber) => {
      const subscriberIndex = subscribers.indexOf(subscriber);

      if (subscriberIndex > -1) {
        subscribers.splice(subscriberIndex, 1);
      }
    },
  };
};
